<template>
    <main>
        <h2 class="subtitle is-5">Plan</h2>
        <section class="box mb-1">
            <section class="field mb-2"
                     v-for="(plan, index) in plansP"
                     :key="index"
            >
                <input type="hidden"
                       :name="'pdca[' + plan.type + '][' + index + '][id]'"
                       v-model="plan.id"
                />
                <input type="hidden"
                       :name="'pdca[' + plan.type + '][' + index + '][is_grantt]'"
                       v-model="plan.is_grantt"
                />
                <div class="field is-horizontal">
                    <div class="field-label">
                        <label class="label">ขั้นตอน {{ index + 1}}</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <input type="text" class="input"
                                   :name="'pdca[' + plan.type + '][' + index + '][title]'"
                                   v-model="plan.title"
                            />
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal mb-2">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <div class="field is-grouped">
                            <div class="control">
                                <label class="label mr-1">ระยะเวลาดำเนินการ</label>
                            </div>
                            <p class="control">
                                <vue-datepicker :name="'pdca[' + plan.type + '][' + index + '][start_date]'"
                                                v-model="plan.start_date"
                                />
                            </p>
                            <div class="control">
                                <p class="label">&nbsp;ถึง&nbsp;</p>
                            </div>
                            <p class="control">
                                <vue-datepicker :name="'pdca[' + plan.type + '][' + index + '][end_date]'"
                                                :min-date="plan.start_date"
                                                v-model="plan.end_date"
                                />
                            </p>
                        </div>
                        <p class="control is-right">
                              <span class="delete"
                                    tabindex="-1"
                                    @click.prevent="deletePlan(index)">
                              </span>
                        </p>
                    </div>
                </div>
            </section>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label"></label>
                </div>
                <div class="field-body">
                    <button type="button" class="button is-300"
                            @click.prevent="addPlan"
                    >
                        เพิ่มขั้นตอน
                    </button>
                </div>
            </div>
        </section>
    </main>
</template>
<script type="text/babel">
    export default {
        props: {
            project: {type: Object, required: true},
            type: {type: String, required: true},
        },

        computed: {
            plansP() {
                return this.project.pdca.filter((plan) => plan.type === this.type);
            }
        },

        methods: {
            addPlan() {
                this.plansP.push({
                    id: null,
                    type: this.type,
                    title: null,
                    start_date: null,
                    end_date: null,
                    is_grantt: true
                });
                this.$forceUpdate();
            },

            deletePlan(index) {
                console.log(index);
                // this.project.pdca.splice(index, 1);
                this.plansP.splice(index, 1);
                this.$forceUpdate();
            },
        }
    }
</script>